import React from 'react'
export function Footer() {
	return (
		<div className='w-full bg-main-dark text-white text-xs '>
			<div className='xl:px-40 pb-12 lg:px-20 md:px-10 sm:px-5 px-10'>
				<div className='w-full pt-12 flex flex-col sm:flex-row space-y-2 justify-start'>
					<div className='w-full sm:w-2/5 pr-6 flex flex-col space-y-4'>
						<img width='109' height='32' alt='Logo' src='img/logo.png' />
						<p className=''>Glory to the winners!</p>
						<p className=''>
							Betish™ All rights reserved. License no.<br></br>
							8048/JAZ2020-077 Curaçao
						</p>
					</div>
					<div className='w-full sm:w-1/5 flex flex-col space-y-4'>
						<a className='' href='https://betish.com/about-us'>
							About us
						</a>
						<a className='' href='https://betish.com/what'>
							Whats Betish?
						</a>
					</div>
					<div className='w-full sm:w-1/5 flex flex-col space-y-4'>
						<a className='' href='https://betish.com/terms-and-conditions'>
							Terms and Conditions
						</a>
						<a className='' href='https://betish.com/privacy'>
							Privacy Policy
						</a>
					</div>
					<div className='w-full sm:w-1/5 flex flex-col space-y-4'>
						<a className='' href='https://betish.com/rules'>
							Rules
						</a>
						<a className='' href='https://betish.com/safe-gambling'>
							Safe Gambling
						</a>
					</div>
					<div className='w-full sm:w-1/5 flex flex-col space-y-4'>
						<a className='' href='https://betish.com/faq'>
							FAQ
						</a>
						<a className='' href='https://betish.com/help'>
							Help Center
						</a>
						<a className='' href='https://betish.com/tutorials'>
							Tutorials
						</a>
					</div>
				</div>
			</div>
		</div>
	)
}
